import React,{useState,useEffect} from 'react'
import { comprobar } from '../Funciones'
import { encriptar } from '../Funciones'
import { useLocation,useNavigate } from 'react-router-dom'
import uuid from 'react-uuid'
import axios from 'axios'
export default function EditUsuario({usuario,setLog}){
const navigate=useNavigate()
    const [error,setError]=useState(false)
    const [mensaje,setMensaje]=useState("")
    const[nombre,setNombre]=useState(usuario.nombre)
    const[apellido1,setApe1]=useState(usuario.apellido1)
    const[apellido2,setApe2]=useState(usuario.apellido2)
    const[nick,setNick]=useState(usuario.nick)
    const[clave,setClave]=useState("")
    const[clave_repe,setClaveRepe]=useState("")
    const[email,setEmail]=useState(usuario.email)
    const[telefono,setTlfno]=useState(usuario.telefono)
    const onChange=(event)=>{
        setError(false)
        if (event.target.name=="nombre"){
            setNombre(event.target.value.replaceAll(" ",""))
        }
        else if (event.target.name=="apellido1"){
            setApe1(event.target.value.replaceAll(" ",""))
        }
        else if (event.target.name=="apellido2"){
            setApe2(event.target.value.replaceAll(" ",""))
        }
        else if (event.target.name=="nick"){
            setNick(event.target.value.replaceAll(" ",""))
        }
        else if (event.target.name=="clave"){
            if (comprobar(event.target.value)){
                setClave(event.target.value)
            }
            else{
                setClave('')
            }
        }
        else if (event.target.name=="clave_repe"){
            if (comprobar(event.target.value)){
                setClaveRepe(event.target.value)
            }
            else{
                setClaveRepe('')
            }
        }
        else if (event.target.name=="email"){
            setEmail(event.target.value.replaceAll(" ",""))
        }
        else if (event.target.name=="telefono"){
            setTlfno(event.target.value.replaceAll(" ",""))
        }
    }
    const Click=()=>{
        const nuevo={
            id:usuario.id,
            nombre:nombre,
            apellido1:apellido1,
            apellido2:apellido2,
            nick:nick,
            clave:encriptar(clave),
            email:email,
            telefono:telefono,
            administrador:usuario.administrador,
            operativo:true,
            perfil:usuario.perfil
        }
        if (nuevo.nombre.length>0 && nuevo.apellido1.length>0 && nuevo.apellido2.length>0 && nuevo.nick.length>0 && clave.length>0 && clave==clave_repe && nuevo.email.length>0 && nuevo.telefono.length>0){
            axios.get("https://www.asinova.es/webapi/api/Usuarios/sin-perfil/abierto-cerrado")
            .then(res=>{
                if (res.data.find(x=>x.nick==nuevo.nick && x.id!=nuevo.id)!=null){
                    setError(true)
                    setMensaje("Nick ya existente")
                }
                else if (res.data.find(x=>x.clave==nuevo.clave && x.id!=nuevo.id)!=null){
                    setError(true)
                    setMensaje("Contraseña ya existente")
                }
                else if (res.data.find(x=>x.email==nuevo.email && x.id!=nuevo.id)!=null){
                    setError(true)
                    setMensaje("Email ya existente")
                }
                else if (res.data.find(x=>x.telefono==nuevo.telefono && x.id!=nuevo.id)!=null){
                    setError(true)
                    setMensaje("Teléfono ya existente")
                }
                else{
                    return axios.put("https://www.asinova.es/webapi/api/Usuarios",nuevo)
                    .then(()=>{
                        setLog(nuevo)
                        localStorage.setItem("log",JSON.stringify(nuevo))
                        navigate("/grp/clientes")
                    })
                }
            })
        }
        else{
            setError(true)
            if (nuevo.nombre.length==0){
                setMensaje("Falta el nombre")
            }
            else if (nuevo.apellido1.length==0){
                setMensaje("Falta el 1º apellido")
            }
            else if (nuevo.apellido2.length==0){
                setMensaje("Falta el 2º apellido")
            }
            else if (nuevo.nick.length==0){
                setMensaje("Falta el nick")
            }
            else if (clave.length==0){
                setMensaje("La contraseña debe tener como mínimo 8 caracteres, 1 mayúscula, 1 minúsucula, 1 nº y un símbolo. No debe contener espacios")
            }
            else if (clave!=clave_repe){
                setMensaje("Las contraseñas no coinciden")
            }
            else if (nuevo.email.length==0){
                setMensaje("Falta el email")
            }
            else if (nuevo.telefono.length==0){
                setMensaje("Falta el teléfono")
            }
        }
    }
    return(
        <>
            <h1 style={{textAlign:'center',margin:'0.5rem auto'}}>EDITAR USUARIO</h1>
            <div className="formulario-vertical"  style={error?null:{marginBottom:'1rem'}}>
                <input type="text" name="nombre" id="nombre" value={nombre} placeholder="Nombre" onChange={onChange}/>
                <input type="text" name="apellido1" id="apellido1" value={apellido1} placeholder="1º Apellido" onChange={onChange}/>
                <input type="text" name="apellido2" id="apellido2" value={apellido2} placeholder="2º Apellido" onChange={onChange}/>
                <input type="text" name="nick" id="nick" placeholder="Nick" value={nick} onChange={onChange}/>
                <input type="password" name="clave" id="clave" className={clave.length==0?'vacio':''} placeholder="Contraseña" onChange={onChange}/>
                <input type="password" name="clave_repe" id="clave_repe"  className={clave_repe.length==0?'vacio':clave!=clave_repe?'error':''} placeholder="Repetir Contraseña" onChange={onChange}/>
                <input type="email" name="email" id="email" placeholder="Email" value={email} onChange={onChange}/>
                <input type="text" name="telefono" id="telefono" placeholder="Teléfono" value={telefono} onChange={onChange}/>
            </div>
            {error?<p className='mensaje-error'><b>ERROR: {mensaje}</b></p>:null}
            <a className='btn-form' style={{margin:'0 auto',width:'fit-content',display:'block'}} onClick={Click}>Enviar</a>
        </>
    )
}